
import './App.css';
import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Footer from './Component/Footer/Footer';
import Header from './Component/Header/Header';
import Home from './Pages/Home/Home';
import Wear from './Pages/Wear/Wear';
import Checkout from './Component/Checkout';
import Addcart from './Component/Addcart/Addcart';

export default function App() {
  return (
      <Router>
          <Header />
          
          <Routes>
              <Route path='/' element={<Home />} />
              {/* <Route path='/about' element={<About />} /> */}
              {/* <Route path='/contact' element={<Contact />} /> */}
              <Route path='/wear' element={<Wear />} />
              <Route path='/addcart' element={<Addcart/>} />

    
              <Route path='/checkout' element={<Checkout/>} />
        
              {/* <Route path='/cotton' element={<Cotton />} /> */}
              {/* <Route path='/kurta' element={<Kurta />} /> */}
              {/* <Route path='/karandi' element={<Karandi />} /> */}
              {/* <Route path='/menshawal' element={<Menshawal />} /> */}
              {/* <Route path='/washwear' element={<Washwear />} /> */}

          </Routes>
          <Footer />
      </Router>
  )
}
